import { render } from "./CometChatActionMessageBubble.vue?vue&type=template&id=0f43bbe8"
import script from "./CometChatActionMessageBubble.vue?vue&type=script&lang=js"
export * from "./CometChatActionMessageBubble.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__